export default {
  setSports: (state, sports) => {
    state.all = sports
  },
}
